import { P2TextDescription } from 'react-bootstrap-common-script'
import { useAppSelector } from '../../../redux/hook';
import { useGetReferDocumentsQuery } from '../../../redux/services/getStageE';
import { LottieLoader } from '../../../components/loader';
import ImageIcon from '../../../assets/svg/image';
import PdfIcon from '../../../assets/svg/pdf';
import { downloadFile } from '../../../utils/download-file';

function DocumentsToReferSegment() {

  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const queryParameters = new URLSearchParams(window.location.search)
  const application_id = queryParameters.get("application_id");

  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const { data, isLoading } = useGetReferDocumentsQuery({ application_id: application_id!, uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? ""},{ skip: !application_id });


  if(isLoading){
    return <>
      <LottieLoader/>
    </>
  }
  return (
    <div className='polymer-stage-e-documents_refer px-4'>
      <P2TextDescription color='#333' title={"Documents to Refer"} description={"These are the documents that you will need to sign during completion appointment."} />
      {data?.length > 0 && <div className='polymer-stage-e-card'>
        {data.map((e:any, _index:number) => {
          const key = _index;
          return <div className="d-flex gap-2" key={key}>
              <div className="polymer-file-selection-segment__file-container__svg-container">
                {e.name?.split(".").pop()?.toLocaleLowerCase() === "png" || e.name?.split(".").pop()?.toLocaleLowerCase() === "jpg" ? ( <ImageIcon /> ) : ( <PdfIcon /> )}
              </div>
              <a href={e.key} onClick={(event)=>{
                event.preventDefault();
                downloadFile(e.key, singpassToken);
              }} target="_blank" rel="noreferrer" className="polymer-text-links">
                {e.name}
              </a>
            </div>
        })}
      </div>}
    </div>
  )
}

export default DocumentsToReferSegment